import { Box, Flex, Text } from 'rebass/styled-components';
import React, { FunctionComponent, useState } from 'react';
import Collapsible from 'react-collapsible';
import {
  CardBase, Card,
} from '.';
import { CollapsibleDrawerArrow } from '..';

import { ReactComponent as Dots } from '../../assets/dots.svg';

export interface IHeaderWrapperProps {
  isOpen: boolean;
}

export interface InfoContent {
  infoHeader: string;
  infoContent: string;
}

export interface InfoCardProps {
  header: string;
  content: Array<InfoContent>;
  footer: React.ReactNode;
}

const InfoCardElement: FunctionComponent<InfoContent> = ({
  infoHeader, infoContent,
}: InfoContent) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <Collapsible
      transitionTime={150}
      trigger={(
        <Flex justifyContent="space-between" sx={{ cursor: 'pointer' }}>
          <Text fontWeight={isOpen ? 700 : 400} variant="primary">
            {infoHeader}
          </Text>
          <Box color="primary">
            <CollapsibleDrawerArrow isOpen={isOpen} />
          </Box>
        </Flex>
      )}
      onOpening={() => {
        setOpen(true);
      }}
      onClosing={() => {
        setOpen(false);
      }}
    >
      <Card p={4} mt={2}>
        <Text variant="p3">{infoContent}</Text>
      </Card>
    </Collapsible>
  );
};

const InfoCard: FunctionComponent<InfoCardProps> = ({
  header, content, footer,
}: InfoCardProps) => (
  <CardBase p={5}>
    <Box sx={{
      position: 'absolute', right: 0, top: '18px',
    }}
    >
      <Dots />
    </Box>
    <Flex flexDirection="column">
      <Text variant="h3" mb={4}>
        {header}
      </Text>
      <Box>
        {content?.map(({ infoHeader, infoContent }, idx) => (
          <Box mt={idx > 0 ? 3 : 0} key={infoHeader}>
            <InfoCardElement infoHeader={infoHeader} infoContent={infoContent} />
          </Box>
        ))}
      </Box>
      <Box mt={5}>
        {footer}
      </Box>
    </Flex>
  </CardBase>
);

export default InfoCard;
